import {
  createContext,
  Dispatch,
  useContext,
  useEffect,
  useState,
} from "react";
import { Viewer } from "./viewer";
import { observe } from "../utils/observe";

export const ViewerContext = createContext<Viewer>(null as Viewer);

export const useViewer = () => {
  return useContext(ViewerContext);
};
export function useViewerValue<T extends keyof Viewer>(key: T) {
  const viewer = useContext(ViewerContext);

  const [value, setValue] = useState(viewer[key] as any);
  useEffect(() => {
    if (!viewer) return;
    observe(viewer, [key], () => {
      setValue(viewer[key]);
    });
  }, [viewer, key]);

  return value as Viewer[T];
}
